//----------------------------------------------
//save polyline or polygon
//----------------------------------------------
import { createUUID } from '../../utils/createUuid'
import { replaceAll } from '../../utils/replaceAll'
import { ReinosMaps } from '../../core'

ReinosMaps.prototype.saveArtOverlay = function (mapID, object, type, keys) {
  const self = this

  //set the type array, always with s like polylines or circles
  const type_array = type + 's'

  if (self[type_array] === undefined) {
    self[type_array] = {}
  }

  if (type !== undefined && object !== undefined) {

    //set the map array
    if (self[type_array][mapID] === undefined) {
      self[type_array][mapID] = []
    }

    //get the index
    const index = self[type_array][mapID].length

    //set markerNumber
    object.objectNumber = index

    //set the uuuid
    object.objectUUID = createUUID()

    //set the arrays
    self[type_array][mapID][index] = []
    self[type_array][mapID][index]['object'] = object
    self[type_array][mapID][index]['keys'] = [index, object.objectUUID]

    //add the extra keys
    //create the custom keys for the marker
    if (typeof keys === 'string') {
      const _keys = keys.split(':')

      _keys.forEach(_key => {
        _key = _key.trim()

        self[type_array][mapID][index]['keys'].push(_key)
        self[type_array][mapID][index]['keys'].push(_key.toLowerCase())
        self[type_array][mapID][index]['keys'].push(replaceAll(_key, ' ', '_'))
        self[type_array][mapID][index]['keys'].push(replaceAll(_key, ' ', '_').toLowerCase())
        self[type_array][mapID][index]['keys'].push(replaceAll(_key, ' ', '-'))
        self[type_array][mapID][index]['keys'].push(replaceAll(_key, ' ', '-').toLowerCase())

        //remove duplicated
        self[type_array][mapID][index]['keys'] = [...new Set(self[type_array][mapID][index]['keys'])]
      })
    }

    //return number
    return object.objectNumber
  }
}
